import React from "react";

// COMPONENTS
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";

// REDUX / UTILS
import { getTranslateByKey } from "@/main/services/utils";
import { IntegrationCodeResponse } from "@/main/models/response";
import { IntegrationCodeRequest } from "@/main/models/request";
import { integrationCodeApi } from "@/main/api";
import { RowHeaderTextCenter } from "@/main/components/shared/styles";

// COMPONENTS & STYLES LOCAL
import RowDataMappingCode from "./rowDataMappingCode/rowDataMappingCode";
import * as S from "./styles";

interface IGridMappingCodesProps {
	dataGrid: IntegrationCodeResponse[];
	formFilters: IntegrationCodeRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<IntegrationCodeResponse[]>>;
}
function GridMappingCodes({ dataGrid, formFilters, setDataGrid }: IGridMappingCodesProps) {
	const rowsHeader = [
		getTranslateByKey("information.code"),
		getTranslateByKey("information.description"),
		getTranslateByKey("information.interface"),
		getTranslateByKey("information.mappingType"),
		getTranslateByKey("information.company"),
		<RowHeaderTextCenter key="5">{getTranslateByKey("information.status")}</RowHeaderTextCenter>,
	];
	const rowsGroup = ["10%", "responsive", "20%", "20%", "20%", "140px"];
	async function fetchData(request: any) {
		return integrationCodeApi.searchGrid(request).then((response) => response.data);
	}

	function updateRowDataGrid(row: IntegrationCodeResponse) {
		const index = dataGrid.findIndex((item) => item.guidIntegrationCode === row.guidIntegrationCode);
		if (index === -1) return;
		dataGrid[index] = {
			...dataGrid[index],
			code: row.code,
			active: row.active,
		};
		setDataGrid([...dataGrid]);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchData}
				fetchEqualFilters
			>
				<BoxGrid rowHeaders={rowsHeader} sizeColumns={rowsGroup}>
					{dataGrid.map((item) => (
						<RowDataMappingCode
							key={item.guidIntegrationCode}
							updateRowDataGrid={updateRowDataGrid}
							mappingCode={item}
						/>
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridMappingCodes;
